import { HardwareIotsVolumeByTypeListChart } from '../../../statistics/hardware/hardware-iots-volume-by-type-list-chart/hardware-iots-volume-by-type-list-chart.component';
import { Last6MonthsHardwareIotsUptimeWeekdayHeatmapChart } from '../../../statistics/hardware/last-6-months-hardware-iots-uptime-weekday-heatmap-chart/last-6-months-hardware-iots-uptime-weekday-heatmap-chart.component';
import { Last30DaysHardwareIotsUptimeByTypeListChart } from '../../../statistics/hardware/last-30-days-hardware-iots-uptime-by-type-list-chart/last-30-days-hardware-iots-uptime-by-type-list-chart.component';
import { Last30DaysHardwareIotsUptimeLineChart } from '../../../statistics/hardware/last-30-days-hardware-iots-uptime-line-chart/last-30-days-hardware-iots-uptime-line-chart.component';
import { Last30DaysHardwareIotsVolumeByStatusBarChart } from '../../../statistics/hardware/last-30-days-hardware-iots-volume-by-status-bar-chart/last-30-days-hardware-iots-volume-by-status-bar-chart.component';
import { INSIGHTS_GRID_CLASS_NAME, getInsightCardWidthClass } from '../insight-card-width';
import { InsightDetailChrome } from '../insight-detail-chrome.component';
import { InsightId } from '../insight-registry/insight-ids';

export interface HardwareInsightsPageProps {
    accountId: string;
}

/** Standalone Hardware insights content — reusable outside Analytics. */
export const HardwareInsightsPage = ({ accountId }: HardwareInsightsPageProps) => (
    <div className={INSIGHTS_GRID_CLASS_NAME}>
        <div className={getInsightCardWidthClass(2)}>
            <InsightDetailChrome insightId={InsightId.HARDWARE_UPTIME_OVER_TIME}>
                <Last30DaysHardwareIotsUptimeLineChart accountId={accountId} />
            </InsightDetailChrome>
        </div>
        <div className={getInsightCardWidthClass(2)}>
            <InsightDetailChrome insightId={InsightId.HARDWARE_STATUS_MIX_OVER_TIME}>
                <Last30DaysHardwareIotsVolumeByStatusBarChart accountId={accountId} />
            </InsightDetailChrome>
        </div>
        <div className={getInsightCardWidthClass(2)}>
            <InsightDetailChrome insightId={InsightId.HARDWARE_UPTIME_BY_TYPE}>
                <Last30DaysHardwareIotsUptimeByTypeListChart accountId={accountId} />
            </InsightDetailChrome>
        </div>
        <div className={getInsightCardWidthClass(2)}>
            <InsightDetailChrome insightId={InsightId.HARDWARE_FLEET_BY_TYPE}>
                <HardwareIotsVolumeByTypeListChart accountId={accountId} />
            </InsightDetailChrome>
        </div>
        <div className={getInsightCardWidthClass(2)}>
            <InsightDetailChrome insightId={InsightId.HARDWARE_UPTIME_WEEKDAY_PATTERN}>
                <Last6MonthsHardwareIotsUptimeWeekdayHeatmapChart accountId={accountId} />
            </InsightDetailChrome>
        </div>
    </div>
);
